// NavigationButtons.jsx
import React from "react";
import { Box, Button, useTheme, useMediaQuery } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const QEStrategyCommonButton = ({
  handleBack,
  handleNext,
  backText = "Back",
  nextText = "Next",
  showBack = true,
  showNext = true,
  containerSx = {},
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      display="flex"
      flexDirection={isSmallScreen ? "column" : "row"}
      justifyContent={
        showBack && showNext
          ? isSmallScreen
            ? "center"
            : "space-between"
          : "flex-end"
      }
      alignItems="center"
      mt={2}
      maxWidth="1000px"
      mx="auto"
      gap={isSmallScreen ? 2 : 0}
      sx={containerSx}
    >
      {showBack && (
        <Button
          onClick={handleBack}
          variant="outlined"
          sx={{
            ml: isSmallScreen ? 0 : -2,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 500,
            borderWidth: 2,
            borderColor: "currentColor",
            width: { xs: "100%", sm: 100, md:90  },
            height: 35,
            gap: 0.5,
            fontSize: { xs: "0.875rem", sm: "1rem" },
          }}
          startIcon={<ArrowBackIcon />}
          fullWidth={isSmallScreen}
        >
          {backText}
        </Button>
      )}

      {showNext && (
        <Button
          onClick={handleNext}
          variant="contained"
          sx={{
            mr: isSmallScreen ? 0 : -2,
            borderRadius: 2,
            backgroundColor: "#0094FB",
            textTransform: "none",
            width: { xs: "100%", sm: 100 ,md:90 },
            height: 35,
            fontSize: { xs: "0.875rem", sm: "1rem" },
          }}
          endIcon={<ArrowForwardIcon />}
          fullWidth={isSmallScreen}
        >
          {nextText}
        </Button>
      )}
    </Box>
  );
};

export default QEStrategyCommonButton;
